import React, { useState, useEffect } from 'react';
import './document.css';
import { useSelector } from 'react-redux';
import axios from 'axios';
import env from '../../../environment';
import { isMobile } from 'react-device-detect';
import Avatar from 'antd/lib/avatar/avatar';
import { UserOutlined } from '@ant-design/icons';
import { Col, Row, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import tlf from '../../../assets/onboarding/tlf.svg';
import sabadellPhoto from '../../../assets/init/sabadellPhoto.jpg';
import email from '../../../assets/documents/emailIcon.png';
import { useParams } from 'react-router-dom';
import { MailAtSign01Icon, SmartPhone01Icon, WhatsappIcon } from 'hugeicons-react';
const { Text } = Typography;

const PersonalAnalyst = (props) => {
	let { analyst, mortgageId, managementCode } = props;
	let { stage } = useParams();
	const brand = process.env.REACT_APP_BRAND;
	const userToken = useSelector((state) => state.auth.token);
	const rol = useSelector((state) => state.auth.roles);
	const [dataValues, setDataValues] = useState();
	const renderPhone =
		managementCode === 'sabadell-es' &&
		(stage === 'basic' || stage === 'full' || stage === 'documents')
			? '919 49 94 51'
			: dataValues?.analyst?.phone || 'No number';
	const renderEmail =
		managementCode === 'sabadell-es' &&
		(stage === 'basic' || stage === 'full' || stage === 'documents')
			? 'portalhipotecas@bancsabadell.com'
			: dataValues?.analyst?.email || 'No email';

	if (mortgageId === undefined) {
		mortgageId = analyst?.operationId !== undefined ? analyst?.operationId : analyst?.id;
	}
	const { t } = useTranslation();

	useEffect(() => {
		getPhoto();
	}, []);

	const getPhoto = () => {
		axios
			.get(`${env.api.url}/v1/mortgages/agents/${mortgageId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setDataValues(response.data.data);
			});
	};

	return (
		<>
			{dataValues !== undefined && !isMobile ? (
				<div>
					<Row gutter={[60, 24]} style={{ alignItems: 'center' }}>
						<Col span={24}>
							<Space>
								<Avatar
									size={60}
									icon={<UserOutlined />}
									src={
										dataValues &&
										dataValues.analyst &&
										dataValues.analyst.email.includes('gibobs') ? (
											<img src={sabadellPhoto} alt="sabadell"></img>
										) : dataValues && dataValues.analyst && dataValues.analyst.avatar !== null ? (
											dataValues.analyst.avatar.link
										) : (
											'https://gibobs-assets.s3.eu-central-1.amazonaws.com/assets-dev/6008ddb40164df16002f94c6b1_608a71a603b0c458502cd74a93?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAIS4QMZRS5JUUI7VA%2F20210719%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Date=20210719T064357Z&X-Amz-Expires=300&X-Amz-Signature=7cca0a6445382b1fb12bf1176fb7a3b3e205a9b852e61288ec043e42e51f25ef&X-Amz-SignedHeaders=host'
										) //""
									}
								/>
								<Space direction="vertical" style={{ gap: 0 }}>
									<Text style={{ fontSize: 16, color: '#006DFF', fontWeight: 700 }}>
										{dataValues && dataValues.analyst && dataValues.analyst.name !== null
											? dataValues.analyst.name
											: 'No Name'}
									</Text>
									<Text style={{ fontSize: 12, color: '#212121' }}>
										{t('document.personalAnalyst')}
									</Text>
								</Space>
							</Space>
						</Col>
					</Row>
					<Row>
						<hr
							color="#006DFF"
							size={1}
							border={'1px solid #006DFF'}
							style={{ width: '100%', marginTop: 16 }}></hr>
					</Row>
					{stage !== 'basic' && stage !== 'documents' && stage !== 'analysis' && (
						<Row gutter={24} style={{ marginTop: 8 }}>
							<Col span={24}>
								<Space style={{ gap: 4 }}>
									{brand === 'office' ? (
										<SmartPhone01Icon
											size={18}
											style={{ verticalAlign: 'middle' }}
											aria-hidden="true"
										/>
									) : (
										<a
											href={`https://api.whatsapp.com/send?phone=%2B34${renderPhone}`}
											target="_blank"
											rel="noopener noreferrer"
											aria-label={`Enviar mensaje por WhatsApp al número ${renderPhone}`}
											title={`Enviar WhatsApp a ${renderPhone}`}>
											<WhatsappIcon
												size={18}
												style={{ verticalAlign: 'middle' }}
												color="#006DFF"
												aria-hidden="true"
											/>
										</a>
									)}
									<div style={{ marginTop: 3 }}>
										<Text style={{ color: brand !== 'office' ? '#006DFF' : '#212121' }}>
											{renderPhone}
										</Text>
									</div>
								</Space>
							</Col>
						</Row>
					)}
					{dataValues &&
						dataValues?.analyst &&
						dataValues?.analyst?.showEmail &&
						stage !== 'basic' &&
						stage !== 'documents' &&
						stage !== 'analysis' && (
							<Row gutter={24}>
								<Col span={24}>
									<Space style={{ gap: 4, marginTop: 8 }}>
										{renderEmail && renderEmail.includes('gibobs') ? null : (
											<a
												href={`mailto:${renderEmail}`}
												target="_blank"
												rel="noopener noreferrer"
												aria-label={`Enviar correo electrónico a ${renderEmail}`}
												title={`Enviar correo a ${renderEmail}`}>
												<MailAtSign01Icon
													color="#006DFF"
													size={18}
													style={{ verticalAlign: 'middle' }}
													aria-hidden="true"
												/>
											</a>
										)}
										<Text style={{ color: '#006DFF' }}>{renderEmail}</Text>
									</Space>
								</Col>
							</Row>
						)}
				</div>
			) : null}

			{dataValues !== undefined && isMobile ? (
				<div className="personalInfo" style={{ color: '#988d8d', marginTop: -60 }}>
					{rol != 'realestate' && (
						<div
							style={{
								marginLeft: '60px',
								marginBottom: '10px',
								marginTop: 70
							}}>
							<Avatar
								size={60}
								icon={<UserOutlined />}
								src={
									dataValues && dataValues.analyst && dataValues.analyst.avatar !== null
										? dataValues.analyst.avatar.link
										: 'https://gibobs-assets.s3.eu-central-1.amazonaws.com/assets-dev/6008ddb40164df16002f94c6b1_608a71a603b0c458502cd74a93?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAIS4QMZRS5JUUI7VA%2F20210719%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Date=20210719T064357Z&X-Amz-Expires=300&X-Amz-Signature=7cca0a6445382b1fb12bf1176fb7a3b3e205a9b852e61288ec043e42e51f25ef&X-Amz-SignedHeaders=host' //""
								}
							/>
						</div>
					)}
					{rol === 'realestate' && (
						<div
							style={{
								//marginLeft: "40px",
								//marginBottom: "10px",
								// marginTop: -15,
								position: 'relative',
								left: '50%',
								top: 75
							}}>
							<Avatar
								size={60}
								icon={<UserOutlined />}
								src={
									dataValues.agent.avatar !== null
										? dataValues.agent.avatar.link
										: 'https://gibobs-assets.s3.eu-central-1.amazonaws.com/assets-dev/6008ddb40164df16002f94c6b1_608a71a603b0c458502cd74a93?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAIS4QMZRS5JUUI7VA%2F20210719%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Date=20210719T064357Z&X-Amz-Expires=300&X-Amz-Signature=7cca0a6445382b1fb12bf1176fb7a3b3e205a9b852e61288ec043e42e51f25ef&X-Amz-SignedHeaders=host' //""
								}
							/>
						</div>
					)}
					{rol !== 'realestate' && (
						<span
							style={{
								marginTop: '20px',
								fontSize: '12px',
								color: '#2F4858',
								lineHeight: '100%',
								textAlign: 'center',
								display: 'flex',
								justifyContent: 'center'
							}}>
							{dataValues && dataValues.analyst && dataValues.analyst.name !== null
								? dataValues.analyst.name
								: 'No Name'}
						</span>
					)}
					{rol === 'realestate' && (
						<span
							style={{
								marginTop: '-40px',
								fontSize: '12px',
								color: '#2F4858',
								justifyContent: 'left',
								fontWeight: 500,
								color: '#2F4858'
							}}>
							{dataValues.agent.name !== null ? dataValues.agent.name : 'No Name'}
						</span>
					)}
					{rol !== 'realestate' && (
						<div
							style={{
								color: '#02C3CD',
								marginTop: '2px',
								marginLeft: '-20px',
								textAlign: 'center'
							}}>
							<span
								style={{
									marginLeft: '25px',
									fontSize: '16px',
									color: '#02C3CD',
									fontWeight: 'bold',
									lineHeight: '100%',
									border: 'none'
								}}>
								{process.env.REACT_APP_BRAND === 'office'
									? '965 000 380'
									: dataValues && dataValues.analyst && dataValues.analyst.phone !== null
									? dataValues.analyst.phone
									: 'No Number'}
							</span>
						</div>
					)}
					{rol === 'realestate' && (
						<div
							style={{
								color: '#02C3CD',
								marginTop: '2px',
								textAlign: 'left'
							}}>
							<span
								style={{
									fontSize: '18px',
									color: '#02C3CD',
									fontWeight: 'bold',
									border: 'none'
								}}>
								{process.env.REACT_APP_BRAND === 'office'
									? '965 000 380'
									: dataValues.agent.phone !== null
									? dataValues.agent.phone
									: 'No Number'}
							</span>
						</div>
					)}
					{rol !== 'realestate' && (
						<div
							style={{
								color: '#748EA0',
								marginTop: '0px',
								marginLeft: '-20px',
								textAlign: 'center'
							}}>
							<span
								style={{
									marginLeft: '15px',
									fontSize: '10px',
									color: '#748EA0',
									fontWeight: 400,
									lineHeight: '100%',
									border: 'none'
								}}>
								{dataValues && dataValues.analyst && dataValues.analyst.email !== null
									? dataValues.analyst.email.replace('hipotecaprimero', 'gibobs')
									: 'No email'}
							</span>
						</div>
					)}
					{rol === 'realestate' && (
						<div
							style={{
								color: '#748EA0',
								textAlign: 'left'
							}}>
							<span
								style={{
									fontSize: '10px',
									color: '#748EA0',
									fontWeight: 400,
									color: '#748EA0'
								}}>
								{dataValues.agent.email !== null
									? dataValues.agent.email.replace('hipotecaprimero', 'gibobs')
									: 'No email'}
							</span>
						</div>
					)}
				</div>
			) : null}
		</>
	);
};

export default PersonalAnalyst;
